<div id="img-carrousel-promotions" *ngIf="!diviceXs" >
    <mat-carousel timings="250ms ease-in" [autoplay]="true" interval="4000" color="#5eda19" maxWidth="auto" slideHeight="200px" [slides]="slidesList?.length" [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="false"
        [maintainAspectRatio]="false" orientation="ltr">

        <mat-carousel-slide *ngFor="let slide of slidesList let i = index" [image]="slide.url" overlayColor="transparent" [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
</div>

<div id="img-carrousel-promotions" *ngIf="diviceXs" >
    <mat-carousel timings="250ms ease-in" [autoplay]="true" interval="4000" color="#5eda19" maxWidth="auto" slideHeight="250px" [slides]="slidesList?.length" [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="false"
        [maintainAspectRatio]="false" orientation="ltr">

        <mat-carousel-slide *ngFor="let slide of slidesListCell let i = index" [image]="slide.url" overlayColor="transparent" [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
</div>